import React from "react";
import { useParams } from "react-router-dom";
import CaseProvider from "./CaseProvider";

export default function CaseRouteProvider({ children }: { children?: React.ReactNode }) {
  const { productUrlPart, productId } = useParams();
  const parsedProductId = productId ? parseInt(productId, 10) : 0;

  if (!productUrlPart || parsedProductId <= 0) {
    return <>{children}</>;
  }

  return (
    <CaseProvider caseUrlPart={productUrlPart} caseId={parsedProductId}>
      {children}
    </CaseProvider>
  );
}
